import { useMemo, useState } from 'react'
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'
import type { RecordRow } from '../types'
import { humanValue, label } from '../lib/labels'
import { EmptyState } from './ui'

type Sort = { key: string; dir: 'asc' | 'desc' } | null

export function DataTable({ rows, columns, onRowClick, selectedKey, rowKey, maxHeight = 'calc(100vh - 300px)' }: { rows: RecordRow[]; columns: string[]; onRowClick?: (row: RecordRow) => void; selectedKey?: string; rowKey?: (row: RecordRow) => string; maxHeight?: string }) {
  const [sort, setSort] = useState<Sort>(null)
  const sorted = useMemo(() => {
    if (!sort) return rows
    return [...rows].sort((a,b) => {
      const av=a[sort.key], bv=b[sort.key]
      if (av == null && bv == null) return 0
      if (av == null) return 1
      if (bv == null) return -1
      const cmp = typeof av === 'number' && typeof bv === 'number' ? av-bv : String(av).localeCompare(String(bv), 'ru', { numeric:true })
      return sort.dir === 'asc' ? cmp : -cmp
    })
  }, [rows, sort])

  if (!rows.length) return <EmptyState title="Здесь пока пусто" text="Данные появятся после добавления или импорта."/>
  const toggleSort=(key:string)=>setSort(s=>!s||s.key!==key?{key,dir:'asc'}:s.dir==='asc'?{key,dir:'desc'}:null)

  return <div className="table-wrap" style={{ maxHeight }}><table className="data-table"><thead><tr>{columns.map(c => <th key={c}><button onClick={() => toggleSort(c)}>{label(c)}{sort?.key===c?(sort.dir==='asc'?<ArrowUp size={13}/>:<ArrowDown size={13}/>):<ChevronsUpDown size={13}/>}</button></th>)}</tr></thead><tbody>{sorted.map((row, i) => {
    const key = rowKey ? rowKey(row) : String(row.id ?? row.experiment_id ?? row.source_id ?? row.compound_id ?? i)
    return <tr key={key} className={selectedKey===key?'selected':''} onClick={() => onRowClick?.(row)}>{columns.map(c => <td key={c} title={humanValue(row[c])}><Cell value={row[c]} column={c}/></td>)}</tr>
  })}</tbody></table></div>
}

function Cell({ value, column }: { value: any; column: string }) {
  if (typeof value === 'boolean' || column === 'enabled' || column === 'schema_valid' || column === 'literal_verified') {
    const yes = value === true || value === 1
    return <span className={`bool-dot ${yes?'yes':'no'}`}>{yes ? 'Да' : 'Нет'}</span>
  }
  return <>{humanValue(value)}</>
}
